/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.06421 10.1938C8.35151 10.8174 7.99515 11.1292 7.86415 11.4987C7.74913 11.823 7.74913 12.177 7.86415 12.5013C7.99515 12.8708 8.35151 13.1826 9.06421 13.8062L11.0196 15.5171C12.2838 16.6233 12.9159 17.1765 13.4521 17.1936C13.918 17.2085 14.3643 17.0059 14.6598 16.6455C15 16.2308 15 15.3908 15 13.711L15 10.289C15 8.60917 15 7.76923 14.6598 7.35445C14.3643 6.99405 13.918 6.79153 13.4521 6.80642C12.9159 6.82355 12.2838 7.37665 11.0196 8.48286L9.06421 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10ZM9.06421 10.1938C8.35151 10.8174 7.99515 11.1292 7.86415 11.4987C7.74913 11.823 7.74913 12.177 7.86415 12.5013C7.99515 12.8708 8.35151 13.1826 9.06421 13.8062L11.0196 15.5171C12.2838 16.6233 12.9159 17.1765 13.4521 17.1936C13.918 17.2085 14.3643 17.0059 14.6598 16.6455C15 16.2308 15 15.3908 15 13.711V10.289C15 8.60917 15 7.76923 14.6598 7.35445C14.3643 6.99405 13.918 6.79153 13.4521 6.80642C12.9159 6.82355 12.2838 7.37665 11.0196 8.48286L9.06421 10.1938Z"
				fill="currentColor"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.06421 10.1938C8.35151 10.8174 7.99515 11.1292 7.86415 11.4987C7.74913 11.823 7.74913 12.177 7.86415 12.5013C7.99515 12.8708 8.35151 13.1826 9.06421 13.8062L11.0196 15.5171C12.2838 16.6233 12.9159 17.1765 13.4521 17.1936C13.918 17.2085 14.3643 17.0059 14.6598 16.6455C15 16.2308 15 15.3908 15 13.711V10.289C15 8.60917 15 7.76923 14.6598 7.35445C14.3643 6.99405 13.918 6.79153 13.4521 6.80642C12.9159 6.82355 12.2838 7.37665 11.0196 8.48286L9.06421 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.69478 11.5365C8.80607 11.194 9.10308 10.897 9.6971 10.303L10.903 9.09708C12.1881 7.81195 12.8307 7.16939 13.3824 7.12597C13.861 7.0883 14.3288 7.28206 14.6407 7.64717C15 8.06797 15 8.97669 15 10.7941L15 13.2059C15 15.0234 15 15.9321 14.6407 16.3529C14.3288 16.718 13.861 16.9118 13.3824 16.8741C12.8307 16.8307 12.1881 16.1881 10.903 14.903L9.6971 13.6971L9.69709 13.6971C9.10308 13.1031 8.80607 12.806 8.69478 12.4636C8.5969 12.1623 8.5969 11.8378 8.69478 11.5365Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M11.0196 8.48286L9.06421 10.1938C8.35151 10.8174 7.99515 11.1292 7.86415 11.4987C7.74913 11.823 7.74913 12.177 7.86415 12.5013C7.99515 12.8708 8.35151 13.1826 9.06421 13.8062L11.0196 15.5171C12.2838 16.6233 12.9159 17.1765 13.4521 17.1936C13.918 17.2085 14.3643 17.0059 14.6598 16.6455C15 16.2308 15 15.3908 15 13.711V10.289C15 8.60917 15 7.76923 14.6598 7.35445C14.3643 6.99405 13.918 6.79153 13.4521 6.80642C12.9159 6.82355 12.2838 7.37665 11.0196 8.48286Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.06421 10.1938C8.35151 10.8174 7.99515 11.1292 7.86415 11.4987C7.74913 11.823 7.74913 12.177 7.86415 12.5013C7.99515 12.8708 8.35151 13.1826 9.06421 13.8062L11.0196 15.5171C12.2838 16.6233 12.9159 17.1765 13.4521 17.1936C13.918 17.2085 14.3643 17.0059 14.6598 16.6455C15 16.2308 15 15.3908 15 13.711V10.289C15 8.60917 15 7.76923 14.6598 7.35445C14.3643 6.99405 13.918 6.79153 13.4521 6.80642C12.9159 6.82355 12.2838 7.37665 11.0196 8.48286L9.06421 10.1938Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				d="M9.69732 10.303C9.10329 10.897 8.80628 11.194 8.695 11.5365C8.59711 11.8378 8.59711 12.1623 8.695 12.4636C8.80628 12.806 9.10329 13.1031 9.69732 13.6971L10.9032 14.903C12.1883 16.1881 12.8309 16.8307 13.3826 16.8741C13.8613 16.9118 14.329 16.718 14.6409 16.3529C15.0003 15.9321 15.0003 15.0234 15.0003 13.2059V10.7941C15.0003 8.97669 15.0003 8.06797 14.6409 7.64717C14.329 7.28206 13.8612 7.0883 13.3826 7.12597C12.8309 7.16939 12.1883 7.81195 10.9032 9.09708L9.69732 10.303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
